module.exports = __webpack_public_path__ + "img/tgo.768769b9.png";